import {
    Add as AddIcon,
    Archive as ArchiveIcon,
    Article as ArticleIcon,
    AttachFile as AttachFileIcon,
    Audiotrack as AudioIcon,
    Close as CloseIcon,
    CloudUpload as CloudUploadIcon,
    Create as CreateIcon,
    Delete as DeleteIcon,
    Description as DocIcon,
    Edit as EditIcon,
    FormatAlignCenter as FormatAlignCenterIcon,
    FormatAlignJustify as FormatAlignJustifyIcon,
    FormatAlignLeft as FormatAlignLeftIcon,
    FormatAlignRight as FormatAlignRightIcon,
    FormatBold as FormatBoldIcon,
    FormatColorText as FormatColorTextIcon,
    FormatItalic as FormatItalicIcon,
    FormatListBulleted as FormatListBulletedIcon,
    FormatListNumbered as FormatListNumberedIcon,
    FormatSize as FormatSizeIcon,
    FormatStrikethrough as FormatStrikethroughIcon,
    FormatUnderlined as FormatUnderlinedIcon,
    HorizontalRule as HorizontalRuleIcon,
    Image as ImageIcon,
    ImageOutlined as ImageOutlinedIcon,
    Link as LinkIcon,
    LocalOffer as TagIcon,
    PhotoCamera as CameraIcon,
    PictureAsPdf as PdfIcon,
    Publish as PublishIcon,
    Settings as SettingsIcon,
    Subject as SubjectIcon,
    TableChart as TableChartIcon,
    TextFields as TextFieldsIcon,
    Title as TitleIcon,
    Update as UpdateIcon,
    VideoFile as VideoIcon,
    ViewColumn as ViewColumnIcon,
    Visibility as VisibilityIcon,
    InsertDriveFile as FileIcon
} from '@mui/icons-material';
import {
    alpha,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    Paper,
    Radio,
    RadioGroup,
    Stack,
    Tab,
    Tabs,
    TextField,
    Typography,
    useTheme
} from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import { publishBlog, updateBlog, deleteBlogImageById } from '../../services/BlogService';
import { toast } from 'react-toastify';
import { MenuItem } from '@mui/material';

const PublishBlogModal = ({ open, blog, onClose, action, blogId }) => {
    const theme = useTheme();
    const MAX_FILE_SIZE = 5 * 1024 * 1024; 
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const [form, setForm] = useState({
        id: blog?.id || '',
        title: '',
        subtitles: [''],
        sortOrder: '',
        contentType: '',
        content: '',
        published: false,
        isActive: true,
        coverImage: null,
        otherImages: [],
        keywords: ['']
    });

    const [existingImages, setExistingImages] = useState([]);
    const [coverDeleted, setCoverDeleted] = useState(false);
    const [confirmState, setConfirmState] = useState({ open: false, message: '', onConfirm: null });
    const [publishConfirmState, setPublishConfirmState] = useState({ open: false, onConfirm: null });
    const [coverImageLoaded, setCoverImageLoaded] = useState(false);
    const [formattingState, setFormattingState] = useState({
        bold: false,
        italic: false,
        underline: false,
        strikethrough: false,
        listBullet: false,
        listNumber: false,
        alignLeft: true,
        alignCenter: false,
        alignRight: false,
        alignJustify: false
    });

    const [contentRef, setContentRef] = useState(null);
    const selectionRef = useRef(null);
    const [tableDialogOpen, setTableDialogOpen] = useState(false);
    const [tableConfig, setTableConfig] = useState({ rows: 3, columns: 3 });
    const [tableRowDialogOpen, setTableRowDialogOpen] = useState(false);
    const [rowOperation, setRowOperation] = useState({ type: '', position: '', rowIndex: null });
    const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, targetCell: null });
    const [hyperlinkDialogOpen, setHyperlinkDialogOpen] = useState(false);
    const [hyperlinkData, setHyperlinkData] = useState({ url: '', text: '' });
    const [fontStyleDialogOpen, setFontStyleDialogOpen] = useState(false);
    const [fontSizeDialogOpen, setFontSizeDialogOpen] = useState(false);
    const [colorDialogOpen, setColorDialogOpen] = useState(false);
    const [fontStyle, setFontStyle] = useState('Arial');
    const [fontSize, setFontSize] = useState('16px');
    const [textColor, setTextColor] = useState('#000000');

    const styles = {
        dialog: {
            '& .MuiDialog-paper': {
                borderRadius: 6,
                boxShadow: '0 30px 100px rgba(0,0,0,0.2)',
                maxWidth: '1000px',
                width: '95vw',
                maxHeight: '95vh',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }
        },
        dialogTitle: {
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)',
            color: theme.palette.text.primary,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 3,
            position: 'relative',
            borderBottom: '1px solid rgba(255,255,255,0.2)'
        },
        closeButton: {
            color: theme.palette.text.secondary,
            '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.05)'
            }
        },
        dialogContent: {
            p: 0,
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)',
            overflow: 'hidden',
            height: 'calc(95vh - 140px)'
        },
        tabContainer: {
            background: 'rgba(255,255,255,0.8)',
            borderBottom: '1px solid rgba(255,255,255,0.2)',
            '& .MuiTabs-indicator': {
                background: 'linear-gradient(45deg, #667eea, #764ba2)',
                height: 3
            }
        },
        tab: {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
            color: theme.palette.text.secondary,
            '&.Mui-selected': {
                color: theme.palette.primary.main
            }
        },
        tabPanel: {
            p: 3,
            height: 'calc(95vh - 240px)',
            overflow: 'auto'
        },
        card: {
            background: 'rgba(255,255,255,0.9)',
            borderRadius: 4,
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            backdropFilter: 'blur(10px)',
            mb: 3
        },
        cardHeader: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            p: 2,
            borderRadius: '4px 4px 0 0',
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        cardContent: {
            p: 3
        },
        textField: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 3,
                fontSize: '0.875rem',
                background: 'rgba(255,255,255,0.8)',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#667eea'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#667eea',
                    borderWidth: '2px'
                }
            }
        },
        arrayFieldContainer: {
            background: 'rgba(248,250,252,0.8)',
            borderRadius: 3,
            p: 2,
            mb: 1.5,
            border: '1px solid rgba(226,232,240,0.8)',
            transition: 'all 0.2s ease',
            '&:hover': {
                background: 'rgba(248,250,252,1)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }
        },
        addButton: {
            textTransform: 'none',
            borderRadius: 3,
            px: 2.5,
            py: 1,
            fontSize: '0.8rem',
            background: 'linear-gradient(45deg, #667eea, #764ba2)',
            color: 'white',
            boxShadow: '0 4px 12px rgba(102,126,234,0.3)',
            '&:hover': {
                background: 'linear-gradient(45deg, #764ba2, #667eea)',
                boxShadow: '0 6px 16px rgba(102,126,234,0.4)'
            }
        },
        removeButton: {
            color: '#ef4444',
            '&:hover': {
                backgroundColor: 'rgba(239,68,68,0.1)'
            }
        },
        fileUploadArea: {
            border: '2px dashed #cbd5e1',
            borderRadius: 3,
            p: 3,
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            background: 'rgba(248,250,252,0.8)',
            '&:hover': {
                borderColor: '#667eea',
                background: 'rgba(102,126,234,0.02)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 24px rgba(102,126,234,0.15)'
            }
        },
        imagePreview: {
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            border: '2px solid white'
        },
        radioGroup: {
            '& .MuiFormControlLabel-root': {
                margin: '6px 0'
            }
        },
        dialogActions: {
            p: 3,
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(10px)',
            borderTop: '1px solid rgba(255,255,255,0.2)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2
        },
        cancelButton: {
            textTransform: 'none',
            borderRadius: 3,
            px: 3,
            py: 1.5,
            border: '1px solid rgba(203,213,225,0.8)',
            color: theme.palette.text.secondary,
            background: 'rgba(255,255,255,0.8)',
            '&:hover': {
                borderColor: '#cbd5e1',
                background: 'rgba(248,250,252,0.9)'
            }
        },
        submitButton: {
            textTransform: 'none',
            borderRadius: 3,
            px: 3,
            py: 1.5,
            background: 'linear-gradient(45deg, #667eea, #764ba2)',
            color: 'white',
            boxShadow: '0 4px 12px rgba(102,126,234,0.3)',
            '&:hover': {
                background: 'linear-gradient(45deg, #764ba2, #667eea)',
                boxShadow: '0 6px 16px rgba(102,126,234,0.4)'
            },
            '&:disabled': {
                background: 'rgba(156,163,175,0.8)',
                color: 'rgba(107,114,128,0.8)',
                boxShadow: 'none'
            }
        },
        chip: {
            borderRadius: 3,
            fontWeight: 500,
            fontSize: '0.75rem'
        },
        contentField: {
            '& .MuiOutlinedInput-root': {
                minHeight: '300px',
                alignItems: 'flex-start'
            }
        },
        statusCard: {
            background: 'rgba(255,255,255,0.9)',
            borderRadius: 3,
            p: 2,
            border: '1px solid rgba(226,232,240,0.8)',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 2
        },
        formattingToolbar: {
            background: 'linear-gradient(90deg, #f8fafc 80%, #e2e8f0 100%)',
            borderRadius: 3,
            p: 1,
            mb: 2,
            border: '1px solid rgba(226,232,240,0.8)',
            display: 'flex',
            flexWrap: 'nowrap',
            gap: 0.5,
            alignItems: 'center',
            minHeight: 48,
            boxShadow: '0 2px 12px rgba(102,126,234,0.08)',
            overflowX: 'auto',
            px: 1.5,
            scrollbarWidth: 'none', // Firefox
            '&::-webkit-scrollbar': { display: 'none' }, // Chrome, Safari
        },
        toolbarVerticalDivider: {
            width: '1.5px',
            height: 28,
            background: 'linear-gradient(180deg, #e2e8f0 0%, #cbd5e1 100%)',
            mx: 1.5,
            borderRadius: 2,
            opacity: 0.8,
        },
        formatButton: {
            minWidth: 'auto',
            p: 0.5,
            borderRadius: 1,
            color: theme.palette.text.secondary,
            '&:hover': {
                backgroundColor: 'rgba(102,126,234,0.1)',
                color: '#667eea'
            },
            '&.active': {
                backgroundColor: 'rgba(102,126,234,0.2)',
                color: '#667eea'
            }
        },
        formatDivider: {
            width: 1,
            height: 20,
            backgroundColor: 'rgba(226,232,240,0.8)',
            mx: 0.5
        }
    };

    const extractUrlString = (source) => {
        try {
            if (!source || (typeof File !== 'undefined' && source instanceof File)) return '';
            const isPlainObject = (v) => v !== null && Object.prototype.toString.call(v) === '[object Object]';
            const isString = (v) => Object.prototype.toString.call(v) === '[object String]';

            let current = source;
            const maxDepth = 3;
            let depth = 0;
            while (isPlainObject(current) && !Array.isArray(current) && depth < maxDepth) {
                const values = Object.values(current || {});
                if (!values.length) break;
                current = values[0];
                depth += 1;
            }
            if (isString(current)) {
                const str = String(current);
                if (str.includes('{') && str.includes('=') && str.includes('}')) {
                    const match = str.match(/\{[^=]*=([^}]+)\}/);
                    if (match && match[1]) return match[1];
                }
                return str;
            }
            return '';
        } catch { return ''; }
    };

  const cleanPlaceholders = (html = '') => (
    String(html)
      .replace(/\[CONTENT_IMAGE_\d+\]/gi, '')
      .replace(/\(\s*CONTENT_IMAGE_\d+\s*\)/gi, '')
      .replace(/\(\s*CONTENT_IMAGR_\d+\s*\)/gi, '')
      .replace(/CONTENT_IMAGR_\d+/gi, '')
  );

    const cleanupContentStyles = () => {
        if (!contentRef) return;

        const containerStyleReset = {
            border: 'none',
            background: 'none',
            margin: 0,
            padding: 0,
            boxShadow: 'none',
            minHeight: 'unset',
            minWidth: 'unset',
            height: 'unset',
        };

        contentRef.querySelectorAll('div').forEach(div => {
            const onlyChild = div.firstChild;
            const isOnlyImage = onlyChild?.tagName === 'IMG';
            const isOnlyPlaceholder = onlyChild?.tagName === 'SPAN' && /\[CONTENT_IMAGE_\d+\]/.test(onlyChild.innerHTML);
            const isSingleRelevantChild = div.childNodes.length === 1 && (isOnlyImage || isOnlyPlaceholder);
            if (isSingleRelevantChild && isOnlyImage) {
                Object.assign(div.style, containerStyleReset);
                onlyChild.style.height = 'unset';
                onlyChild.style.minHeight = 'unset';
            }
        });

        contentRef.querySelectorAll('span').forEach(span => {
            const onlyChild = span.firstChild;
            const isOnlyImage = span.childNodes.length === 1 && onlyChild?.tagName === 'IMG';
            if (isOnlyImage) {
                Object.assign(span.style, { ...containerStyleReset, display: 'inline' });
                onlyChild.style.height = 'unset';
                onlyChild.style.minHeight = 'unset';
            }
        });
    };

    const removeDanglingImageContainers = () => {
        if (!contentRef) return;
        const nodes = contentRef.querySelectorAll('div, span');
        nodes.forEach(el => {
            const style = (el.getAttribute('style') || '').toLowerCase();
            const looksLikePlaceholder = style.includes('dashed') || style.includes('content-image') || (style.includes('height') && style.includes('200px'));
            const hasImg = !!el.querySelector('img');
            const text = (el.textContent || '').replace(/\u200b/g, '').trim();
            const onlyBr = el.innerHTML && el.innerHTML.replace(/<br\s*\/?>(\s|&nbsp;)*?/gi, '').trim() === '';
            if (!hasImg && (looksLikePlaceholder || onlyBr) && text === '') {
                const br = document.createElement('br');
                try {
                    el.replaceWith(br);
                } catch {
                    if (el.parentNode) el.parentNode.insertBefore(br, el);
                    el.remove();
                }
            }
        });
    };

    useEffect(() => {
        if (open) {
            setIsSubmitting(false);
            setCoverDeleted(false);
            setCoverImageLoaded(false);
            const stringToArray = (value) => {
                if (Array.isArray(value)) return value;
                if (typeof value === 'string' && value.trim()) {
                    return value.split(',').map((item) => item.trim()).filter(Boolean);
                }
                return [''];
            };

            const processExistingImages = (value) => {
                if (Array.isArray(value)) {
                    return value.map(extractUrlString).filter((url) => url && url.trim());
                }
                if (typeof value === 'string' && value.trim()) {
                    return value.split(',').map((u) => u.trim()).filter(Boolean);
                }
                return [];
            };

            if (blog) {
                let contentWithImages = blog.content || '';
                if (Array.isArray(blog.ContentImages) && blog.ContentImages.length) {
                    const indexToUrl = {};
                    blog.ContentImages.forEach((entry) => {
                        const url = extractUrlString(entry);
                        if (!url) return;
                        try {
                            const fname = decodeURIComponent(String(url).split('/').pop().split('?')[0]);
                            const m = fname.match(/contentImage-(\d+)\.(?:png|jpe?g|webp|gif)/i);
                            if (m && m[1]) {
                                indexToUrl[m[1]] = url;
                            }
                        } catch {}
                    });

                    Object.entries(indexToUrl).forEach(([idx, url]) => {
                        const placeholderRe = new RegExp(`\\[CONTENT_IMAGE_${idx}\\]`, 'g');
                        const imageHtml = `<img src="${url}" alt="content-image-${idx}" style="max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 4px; margin-bottom: 10px;" />`;
                        contentWithImages = contentWithImages.replace(placeholderRe, imageHtml);
                    });
                    contentWithImages = cleanPlaceholders(contentWithImages);
                }
                const cleanedContent = cleanPlaceholders(contentWithImages || '');

                setForm({
                    id: blog?.id || '',
                    title: blog.title || '',
                    subtitles: stringToArray(blog.subtitles || blog.subtitle),
                    sortOrder: blog.sortOrder || '',
                    contentType: blog?.contentType,
                    content: cleanedContent,
                    published: blog.published ?? false,
                    isActive: blog.isActive ?? true,
                    coverImage: null,
                    otherImages: [],
                    keywords: stringToArray(blog.keywords)
                });
                setExistingImages(processExistingImages(blog.otherImages || blog.images));
            } else {
                setForm({
                    id: '', title: '', subtitles: [''], sortOrder: '', contentType: '', content: '',
                    published: false, isActive: true, coverImage: null, otherImages: [], keywords: ['']
                });
                setExistingImages([]);
            }
        }
    }, [open, blog]);

    useEffect(() => {
        if (contentRef && form.content !== contentRef.innerHTML) {
            contentRef.innerHTML = form.content;
            setTimeout(cleanupContentStyles, 0);
            setTimeout(ensureImageAlignment, 0);
            setTimeout(removeDanglingImageContainers, 0);
        }
    }, [contentRef, form.content]);

    useEffect(() => {
        if (contentRef) {
            setTimeout(addTableContextMenuListeners, 0);
        }
    }, [contentRef, form.content]);

    useEffect(() => {
        if (contentRef) {
            contentRef.querySelectorAll('a').forEach(link => {
                link.removeEventListener('click', handleLinkClick);
            });
            contentRef.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', handleLinkClick);
                link.style.cursor = 'pointer';
            });
        }
    }, [contentRef, form.content]);

    useEffect(() => {
        const handleGlobalClick = (e) => {
            if (contextMenu.visible) {
                handleContextMenuClose();
            }
        };
        if (contextMenu.visible) {
            document.addEventListener('click', handleGlobalClick);
            return () => document.removeEventListener('click', handleGlobalClick);
        }
    }, [contextMenu.visible]);

    const handleChange = e => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: ['isActive', 'published'].includes(name) ? value === 'true' : value }));
    };

    const handleCoverUpload = e => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error('File must be 5 MB or smaller.');
                e.target.value = '';
                return;
            }
            setForm(prev => ({ ...prev, coverImage: file }));
        }
    };

    const handleOtherImagesUpload = e => {
        const incomingFiles = Array.from(e.target.files || []);
        if (incomingFiles.length === 0) return;
        const validFiles = [];
        let invalidCount = 0;
        for (const f of incomingFiles) {
            if (f && typeof f.size === 'number' && f.size > MAX_FILE_SIZE) {
                invalidCount += 1;
            } else {
                validFiles.push(f);
            }
        }
        if (invalidCount > 0) {
            toast.error(`File size exceeds 5mb. Please upload a file smaller than 5mb.`);
        }
        if (validFiles.length > 0) {
            setForm(prev => ({ ...prev, otherImages: [...prev.otherImages, ...validFiles] }));
        }
        e.target.value = '';
    };

    const removeOtherImage = idx => setForm(prev => {
        const arr = [...prev.otherImages]; arr.splice(idx, 1); return { ...prev, otherImages: arr };
    });

    const applyFormatting = formatType => {
        if (!contentRef) return;
        if (selectionRef.current) {
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(selectionRef.current);
        }
        contentRef.focus();
        const exec = cmd => document.execCommand(cmd, false, null);
        switch (formatType) {
            case 'bold':
                exec('bold');
                setFormattingState(prev => ({ ...prev, bold: !prev.bold }));
                break;
            case 'italic':
                exec('italic');
                setFormattingState(prev => ({ ...prev, italic: !prev.italic }));
                break;
            case 'underline':
                exec('underline');
                setFormattingState(prev => ({ ...prev, underline: !prev.underline }));
                break;
            case 'strikethrough':
                exec('strikethrough');
                setFormattingState(prev => ({ ...prev, strikethrough: !prev.strikethrough }));
                break;
            case 'listBullet':
                exec('insertUnorderedList');
                setFormattingState(prev => ({ ...prev, listBullet: !prev.listBullet }));
                break;
            case 'listNumber':
                exec('insertOrderedList');
                setFormattingState(prev => ({ ...prev, listNumber: !prev.listNumber }));
                break;
            case 'alignLeft':
                exec('justifyLeft');
                setFormattingState(prev => ({ ...prev, alignLeft: true, alignCenter: false, alignRight: false, alignJustify: false }));
                break;
            case 'alignCenter':
                exec('justifyCenter');
                setFormattingState(prev => ({ ...prev, alignLeft: false, alignCenter: true, alignRight: false, alignJustify: false }));
                break;
            case 'alignRight':
                exec('justifyRight');
                setFormattingState(prev => ({ ...prev, alignLeft: false, alignCenter: false, alignRight: true, alignJustify: false }));
                break;
            case 'alignJustify':
                exec('justifyFull');
                setFormattingState(prev => ({ ...prev, alignLeft: false, alignCenter: false, alignRight: false, alignJustify: true }));
                break;
            default:
                return;
        }
        setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
        setTimeout(() => {
            try {
                setFormattingState(prev => ({
                    ...prev,
                    bold: document.queryCommandState('bold'),
                    italic: document.queryCommandState('italic'),
                    underline: document.queryCommandState('underline'),
                    strikethrough: document.queryCommandState('strikethrough'),
                    listBullet: document.queryCommandState('insertUnorderedList'),
                    listNumber: document.queryCommandState('insertOrderedList'),
                    alignLeft: document.queryCommandState('justifyLeft'),
                    alignCenter: document.queryCommandState('justifyCenter'),
                    alignRight: document.queryCommandState('justifyRight'),
                    alignJustify: document.queryCommandState('justifyFull')
                }));
            } catch {
                toast.error('Formatting error, please try again.');
            }
        }, 0);
        setTimeout(() => {
            ensureContentEditable();
            if ([
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
            ].includes(formatType)) {
                ensureImageAlignment();
            }
        }, 0);
    };

    const handleFormattingClick = formatType => applyFormatting(formatType);
    const handleSelectionChange = () => {
        if (!contentRef) return;
        try {
            const sel = window.getSelection();
            if (sel?.rangeCount > 0) {
                selectionRef.current = sel.getRangeAt(0).cloneRange();
                setFormattingState(prev => ({
                    ...prev,
                    bold: document.queryCommandState('bold'),
                    italic: document.queryCommandState('italic'),
                    underline: document.queryCommandState('underline'),
                    strikethrough: document.queryCommandState('strikethrough'),
                    listBullet: document.queryCommandState('insertUnorderedList'),
                    listNumber: document.queryCommandState('insertOrderedList'),
                    alignLeft: document.queryCommandState('justifyLeft'),
                    alignCenter: document.queryCommandState('justifyCenter'),
                    alignRight: document.queryCommandState('justifyRight'),
                    alignJustify: document.queryCommandState('justifyFull')
                }));
                let node = sel.anchorNode;
                if (node?.nodeType === 3) node = node.parentNode;
                let detectedFont = '', detectedSize = '', detectedColor = '';
                let current = node;
                while (current && current !== contentRef && current.nodeType === 1) {
                    const computed = window.getComputedStyle(current);
                    if (!detectedFont && computed.fontFamily) detectedFont = computed.fontFamily;
                    if (!detectedSize && computed.fontSize) detectedSize = computed.fontSize;
                    if (!detectedColor && computed.color) detectedColor = computed.color;
                    current = current.parentNode;
                }
                if (detectedFont) detectedFont = detectedFont.split(',')[0].replace(/['"]/g, '').trim();
                if (detectedSize) {
                    const pxMatch = detectedSize.match(/\d+px/);
                    detectedSize = pxMatch ? pxMatch[0] : detectedSize;
                    const availableSizes = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];
                    if (pxMatch) {
                        const pxValue = parseInt(pxMatch[0]);
                        let closest = availableSizes[0];
                        let minDiff = Math.abs(pxValue - parseInt(closest));
                        for (const sz of availableSizes) {
                            const diff = Math.abs(pxValue - parseInt(sz));
                            if (diff < minDiff) {
                                closest = sz;
                                minDiff = diff;
                            }
                        }
                        detectedSize = closest;
                    }
                }
                if (detectedColor) {
                    const rgbToHex = rgb => {
                        const result = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.exec(rgb);
                        return result ? '#' + result.slice(1).map(x => (+x).toString(16).padStart(2, '0')).join('') : rgb;
                    };
                    if (detectedColor.startsWith('rgb')) detectedColor = rgbToHex(detectedColor);
                }
                if (detectedFont) setFontStyle(detectedFont);
                if (detectedSize) setFontSize(detectedSize);
                if (detectedColor) setTextColor(detectedColor);
            }
        } catch (err) {
            toast.error('Selection change error');
        }
    };

    const getImageUrlsFromHtml = (html) => {
        try {
            const container = document.createElement('div');
            container.innerHTML = html || '';
            const imgs = Array.from(container.querySelectorAll('img'));
            return new Set(imgs.map(img => normalizeUrlForMatch(img?.src || '')));
        } catch { return new Set(); }
    };

    const handleInput = async e => {
        const newContent = e.target.innerHTML;
        try {
            const prevSet = getImageUrlsFromHtml(form.content);
            const nextSet = getImageUrlsFromHtml(newContent);
            const removed = [...prevSet].filter(u => !nextSet.has(u));
            if (removed.length > 0) {
                const removedUrl = removed[0];
                const id = resolveImageIdByUrl(removedUrl);
                if (id) {
                    if (contentRef && form.content !== contentRef.innerHTML) {
                        contentRef.innerHTML = form.content;
                        setTimeout(() => {
                            ensureContentEditable();
                            ensureImageAlignment();
                            cleanupContentStyles();
                            removeDanglingImageContainers();
                        }, 0);
                    }
                    const doDelete = async () => {
                        try {
                            await deleteBlogImageById(id);
                            if (contentRef) {
                                const imgs = Array.from(contentRef.querySelectorAll('img'));
                                const target = imgs.find(img => normalizeUrlForMatch(img.src) === normalizeUrlForMatch(removedUrl));
                                if (target) target.remove();
                                setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                            }
                            toast.success('Image deleted successfully');
                        } catch {
                            toast.error('Failed to delete image');
                        }
                    };
                    openConfirm('Delete this image from content?', doDelete);
                    return;
                }
            }
        } catch {}

        if (newContent !== form.content) setForm(prev => ({ ...prev, content: newContent }));
        setTimeout(removeDanglingImageContainers, 0);
        if (newContent === '' || newContent === '<br>' || newContent === '<div><br></div>') {
            setFormattingState(prev => ({ ...prev, bold: false, italic: false, underline: false, strikethrough: false, listBullet: false, listNumber: false }));
            return;
        }
        setTimeout(() => {
            setFormattingState(prev => ({
                ...prev,
                bold: document.queryCommandState('bold'),
                italic: document.queryCommandState('italic'),
                underline: document.queryCommandState('underline'),
                strikethrough: document.queryCommandState('strikethrough'),
                listBullet: document.queryCommandState('insertUnorderedList'),
                listNumber: document.queryCommandState('insertOrderedList'),
                alignLeft: document.queryCommandState('justifyLeft'),
                alignCenter: document.queryCommandState('justifyCenter'),
                alignRight: document.queryCommandState('justifyRight'),
                alignJustify: document.queryCommandState('justifyFull')
            }));
        }, 0);
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            setTimeout(() => {
                const sel = window.getSelection();
                if (sel?.rangeCount > 0) {
                    const range = sel.getRangeAt(0);
                    if (range.collapsed) {
                        document.execCommand('removeFormat', false, null);
                        setFormattingState(prev => ({ ...prev, bold: false, italic: false, underline: false, strikethrough: false }));
                    }
                }
            }, 0);
        }
    };

    const updateSelectionRef = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) selectionRef.current = sel.getRangeAt(0).cloneRange();
    };

    const ensureContentEditable = () => {
        if (contentRef) {
            contentRef.contentEditable = true;
            if (document.activeElement !== contentRef) {
                contentRef.focus();
            }
        }
    };

    const ensureImageAlignment = () => {
        if (!contentRef) return;
        contentRef.querySelectorAll('img').forEach(img => {
            if (img.style.display === 'block') {
                img.style.display = '';
            }
            if (!img.hasAttribute('data-alignment-handler')) {
                img.setAttribute('data-alignment-handler', 'true');
                img.addEventListener('click', (e) => {
                    e.preventDefault();
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.selectNode(img);
                    sel.removeAllRanges();
                    sel.addRange(range);
                    contentRef.focus();
                });
                img.addEventListener('contextmenu', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const targetUrl = img?.src || '';
                    const doDelete = async () => {
                        try {
                            const id = resolveImageIdByUrl(targetUrl);
                            if (!id) {
                                toast.error('Unable to resolve image id');
                                return;
                            }
                            await deleteBlogImageById(id);
                            img.remove();
                            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                            toast.success('Image deleted successfully');
                        } catch (err) {
                            toast.error('Failed to delete image');
                        }
                    };
                    setConfirmState({ open: true, message: 'Delete this image from content?', onConfirm: doDelete });
                });
            }
        });
    };

    const handleTableInsertion = () => {
        if (contentRef) {
            contentRef.focus();
            const table = document.createElement('table');
            table.style.cssText = 'width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;';

            const thead = document.createElement('thead');
            const headerRow = document.createElement('tr');
            headerRow.style.cssText = 'background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;';

            for (let i = 0; i < tableConfig.columns; i++) {
                const th = document.createElement('th');
                th.style.cssText = 'padding: 12px; text-align: left; border: 1px solid #e2e8f0; font-weight: 600;';
                th.contentEditable = true;
                th.innerHTML = `Header ${i + 1}`;
                headerRow.appendChild(th);
            }
            thead.appendChild(headerRow);
            table.appendChild(thead);

            const tbody = document.createElement('tbody');
            for (let i = 0; i < tableConfig.rows; i++) {
                const row = document.createElement('tr');
                row.style.cssText = i % 2 === 0 ? 'background-color: #f8fafc;' : 'background-color: white;';

                for (let j = 0; j < tableConfig.columns; j++) {
                    const td = document.createElement('td');
                    td.style.cssText = 'padding: 12px; border: 1px solid #e2e8f0; vertical-align: top;';
                    td.contentEditable = true;
                    td.innerHTML = `Cell ${i + 1}-${j + 1}`;
                    row.appendChild(td);
                }
                tbody.appendChild(row);
            }
            table.appendChild(tbody);

            const sel = window.getSelection();
            if (sel.rangeCount > 0) {
                const range = sel.getRangeAt(0);
                range.insertNode(table);
                const brBefore = document.createElement('br');
                const brAfter = document.createElement('br');
                range.setStartBefore(table);
                range.insertNode(brBefore);
                range.setStartAfter(table);
                range.insertNode(brAfter);
                range.setStartAfter(brAfter);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            } else {
                contentRef.appendChild(document.createElement('br'));
                contentRef.appendChild(table);
                contentRef.appendChild(document.createElement('br'));
            }

            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
            setTimeout(ensureContentEditable, 0);
            setTableDialogOpen(false);

            setTimeout(addTableContextMenuListeners, 0);
        }
    };

    const addTableRow = (position, rowIndex = null) => {
        if (!contentRef) return;

        const tables = contentRef.querySelectorAll('table');
        if (tables.length === 0) return;

        const table = tables[0];
        const tbody = table.querySelector('tbody');
        if (!tbody) return;

        const newRow = document.createElement('tr');
        const columnCount = table.querySelector('thead tr')?.children.length || 3;

        const existingRows = tbody.children;
        let rowStyle = 'background-color: white;';
        if (position === 'start') {
            rowStyle = 'background-color: #f8fafc;';
        } else if (position === 'end') {
            rowStyle = existingRows.length % 2 === 0 ? 'background-color: #f8fafc;' : 'background-color: white;';
        } else if (position === 'between' && rowIndex !== null) {
            const insertIndex = rowIndex + 1;
            rowStyle = insertIndex % 2 === 0 ? 'background-color: #f8fafc;' : 'background-color: white;';
        }

        newRow.style.cssText = rowStyle;

        for (let j = 0; j < columnCount; j++) {
            const td = document.createElement('td');
            td.style.cssText = 'padding: 12px; border: 1px solid #e2e8f0; vertical-align: top;';
            td.contentEditable = true;
            td.innerHTML = `New Cell ${j + 1}`;
            newRow.appendChild(td);
        }

        if (position === 'start') {
            tbody.insertBefore(newRow, tbody.firstChild);
        } else if (position === 'end') {
            tbody.appendChild(newRow);
        } else if (position === 'between' && rowIndex !== null) {
            const targetRow = tbody.children[rowIndex];
            if (targetRow) {
                tbody.insertBefore(newRow, targetRow.nextSibling);
            } else {
                tbody.appendChild(newRow);
            }
        }

        setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
        setTimeout(ensureContentEditable, 0);
        setTableRowDialogOpen(false);
    };

    const removeTableRow = (position, rowIndex = null) => {
        if (!contentRef) return;

        const tables = contentRef.querySelectorAll('table');
        if (tables.length === 0) return;

        const table = tables[0];
        const tbody = table.querySelector('tbody');
        if (!tbody || tbody.children.length === 0) return;

        let rowToRemove = null;

        if (position === 'start') {
            rowToRemove = tbody.firstChild;
        } else if (position === 'end') {
            rowToRemove = tbody.lastChild;
        } else if (position === 'between' && rowIndex !== null) {
            rowToRemove = tbody.children[rowIndex];
        }

        if (rowToRemove) {
            tbody.removeChild(rowToRemove);
            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
            setTimeout(ensureContentEditable, 0);
        }

        setTableRowDialogOpen(false);
    };

    const addTableColumn = (position, columnIndex = null) => {
        if (!contentRef) return;

        const tables = contentRef.querySelectorAll('table');
        if (tables.length === 0) return;

        const table = tables[0];
        const thead = table.querySelector('thead tr');
        const tbody = table.querySelector('tbody');

        if (!thead || !tbody) return;

        const newHeaderCell = document.createElement('th');
        newHeaderCell.style.cssText = 'padding: 12px; text-align: left; border: 1px solid #e2e8f0; font-weight: 600;';
        newHeaderCell.contentEditable = true;
        newHeaderCell.innerHTML = `Header ${thead.children.length + 1}`;

        if (position === 'start') {
            thead.insertBefore(newHeaderCell, thead.firstChild);
        } else if (position === 'end') {
            thead.appendChild(newHeaderCell);
        } else if (position === 'between' && columnIndex !== null) {
            const targetCell = thead.children[columnIndex];
            if (targetCell) {
                thead.insertBefore(newHeaderCell, targetCell.nextSibling);
            } else {
                thead.appendChild(newHeaderCell);
            }
        }

        Array.from(tbody.children).forEach((row, rowIndex) => {
            const newCell = document.createElement('td');
            newCell.style.cssText = 'padding: 12px; border: 1px solid #e2e8f0; vertical-align: top;';
            newCell.contentEditable = true;
            newCell.innerHTML = `Cell ${rowIndex + 1}-${row.children.length + 1}`;

            if (position === 'start') {
                row.insertBefore(newCell, row.firstChild);
            } else if (position === 'end') {
                row.appendChild(newCell);
            } else if (position === 'between' && columnIndex !== null) {
                const targetCell = row.children[columnIndex];
                if (targetCell) {
                    row.insertBefore(newCell, targetCell.nextSibling);
                } else {
                    row.appendChild(newCell);
                }
            }
        });

        setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
        setTimeout(ensureContentEditable, 0);
    };

    const removeTableColumn = (position, columnIndex = null) => {
        if (!contentRef) return;

        const tables = contentRef.querySelectorAll('table');
        if (tables.length === 0) return;

        const table = tables[0];
        const thead = table.querySelector('thead tr');
        const tbody = table.querySelector('tbody');

        if (!thead || !tbody) return;

        let columnToRemove = null;

        if (position === 'start') {
            columnToRemove = 0;
        } else if (position === 'end') {
            columnToRemove = thead.children.length - 1;
        } else if (position === 'between' && columnIndex !== null) {
            columnToRemove = columnIndex;
        }

        if (columnToRemove !== null && columnToRemove >= 0 && columnToRemove < thead.children.length) {
            if (thead.children[columnToRemove]) {
                thead.removeChild(thead.children[columnToRemove]);
            }

            Array.from(tbody.children).forEach(row => {
                if (row.children[columnToRemove]) {
                    row.removeChild(row.children[columnToRemove]);
                }
            });

            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
            setTimeout(ensureContentEditable, 0);
        }
    };

    const handleTableContextMenu = (e, cell) => {
        e.preventDefault();
        e.stopPropagation();

        const table = cell.closest('table');
        if (!table) return;

        setContextMenu({
            visible: true,
            x: e.clientX,
            y: e.clientY,
            targetCell: cell
        });
    };

    const handleContextMenuClose = () => {
        setContextMenu({ visible: false, x: 0, y: 0, targetCell: null });
    };

    const handleContextMenuAction = (action, position, rowIndex = null) => {
        if (action === 'add') {
            addTableRow(position, rowIndex);
        } else if (action === 'remove') {
            removeTableRow(position, rowIndex);
        } else if (action === 'addColumn') {
            addTableColumn(position, rowIndex);
        } else if (action === 'removeColumn') {
            removeTableColumn(position, rowIndex);
        }
        handleContextMenuClose();
    };

    const addTableContextMenuListeners = () => {
        if (!contentRef) return;

        contentRef.querySelectorAll('td, th').forEach(cell => {
            cell.removeEventListener('contextmenu', (e) => handleTableContextMenu(e, cell));
        });

        contentRef.querySelectorAll('td, th').forEach(cell => {
            cell.addEventListener('contextmenu', (e) => handleTableContextMenu(e, cell));
        });
    };

    const handleHyperlinkClick = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            const selectedText = range.toString().trim();

            setHyperlinkData({
                url: '',
                text: selectedText || ''
            });
            setHyperlinkDialogOpen(true);
        } else {
            toast.error('Please select text to create a hyperlink');
        }
    };

    const handleHyperlinkInsertion = () => {
        if (!contentRef || !hyperlinkData.url.trim()) return;

        if (selectionRef.current) {
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(selectionRef.current);
        }

        contentRef.focus();
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            const linkText = hyperlinkData.text.trim() || hyperlinkData.url;

            const link = document.createElement('a');
            link.href = hyperlinkData.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.style.cssText = 'color: #667eea; text-decoration: underline; cursor: pointer;';
            link.textContent = linkText;

            range.deleteContents();
            range.insertNode(link);
            range.setStartAfter(link);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            const link = document.createElement('a');
            link.href = hyperlinkData.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.style.cssText = 'color: #667eea; text-decoration: underline; cursor: pointer;';
            link.textContent = hyperlinkData.text.trim() || hyperlinkData.url;

            contentRef.appendChild(link);
            contentRef.appendChild(document.createElement('br'));
        }

        setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
        setTimeout(ensureContentEditable, 0);

        setHyperlinkDialogOpen(false);
        setHyperlinkData({ url: '', text: '' });
    };

    const handleLinkClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const url = e.target.href;
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    const handleFontStyleChange = (style) => {
        if (!contentRef) return;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            if (!range.collapsed) {
                document.execCommand('fontName', false, style);
                setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                setTimeout(ensureContentEditable, 0);
            }
        }
        setFontStyleDialogOpen(false);
    };

    const handleFontSizeChange = (size) => {
        if (!contentRef) return;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            if (!range.collapsed) {
                const sizeMap = {
                    '12px': '1',
                    '14px': '2',
                    '16px': '3',
                    '18px': '4',
                    '20px': '5',
                    '24px': '6',
                    '28px': '7',
                    '32px': '7'
                };

                const execSize = sizeMap[size] || '3';
                document.execCommand('fontSize', false, execSize);
                setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                setTimeout(ensureContentEditable, 0);
            }
        }
        setFontSizeDialogOpen(false);
    };

    const handleColorChange = (color) => {
        if (!contentRef) return;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            if (!range.collapsed) {
                document.execCommand('foreColor', false, color);
                setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                setTimeout(ensureContentEditable, 0);
            }
        }
        setColorDialogOpen(false);
    };

    const handleImageInsertion = e => {
        const file = e.target.files[0];
        if (file && contentRef) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error('Image must be 5 MB or smaller.');
                e.target.value = '';
                return;
            }
            const reader = new FileReader();
            reader.onloadend = async () => {
                contentRef.focus();
                const img = document.createElement('img');
                img.src = reader.result;
                img.style.cssText = 'max-width: 100%; max-height: 200px; object-fit: cover; border-radius: 4px; margin-bottom: 10px;';
                const sel = window.getSelection();
                if (sel.rangeCount > 0) {
                    const range = sel.getRangeAt(0);
                    try {
                        const findTargetImage = (r) => {
                            const isElement = (n) => n && n.nodeType === Node.ELEMENT_NODE;
                            const childAt = (el, idx) => (isElement(el) ? el.childNodes[idx] : null);
                            if (isElement(r.startContainer) && r.startContainer.tagName === 'IMG') return r.startContainer;
                            if (isElement(r.endContainer) && r.endContainer.tagName === 'IMG') return r.endContainer;
                            const startChild = childAt(r.startContainer, r.startOffset);
                            if (startChild && startChild.nodeType === Node.ELEMENT_NODE && startChild.tagName === 'IMG') return startChild;
                            const endChild = childAt(r.endContainer, Math.max(0, r.endOffset - 1));
                            if (endChild && endChild.nodeType === Node.ELEMENT_NODE && endChild.tagName === 'IMG') return endChild;
                            return null;
                        };

                        const targetImg = findTargetImage(range);
                        if (targetImg?.src) {
                            const id = resolveImageIdByUrl(targetImg.src);
                            if (id) { try { await deleteBlogImageById(id); } catch {} }
                            targetImg.replaceWith(img);
                            const br = document.createElement('br');
                            range.setStartAfter(img);
                            range.insertNode(br);
                            range.setStartAfter(br);
                            range.collapse(true);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        } else {
                            range.insertNode(img);
                            const br = document.createElement('br');
                            range.setStartAfter(img);
                            range.insertNode(br);
                            range.setStartAfter(br);
                            range.collapse(true);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    } catch {
                        range.insertNode(img);
                        const br = document.createElement('br');
                        range.setStartAfter(img);
                        range.insertNode(br);
                        range.setStartAfter(br);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                } else {
                    contentRef.appendChild(img);
                    contentRef.appendChild(document.createElement('br'));
                }
                setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
                e.target.value = '';

                setTimeout(() => {
                    ensureContentEditable();
                    ensureImageAlignment();
                    cleanupContentStyles();
                }, 0);
            };
            reader.readAsDataURL(file);
        }
    };

    const normalizeUrlForMatch = (u = '') => {
        try {
            const noQuery = String(u || '').split('?')[0];
            return decodeURIComponent(noQuery);
        } catch { return String(u || '').split('?')[0]; }
    };

    const resolveImageIdByUrl = (url) => {
        try {
            const target = normalizeUrlForMatch(url);
            const scanArray = (arr) => {
                if (!Array.isArray(arr)) return null;
                const isPlainObject = (v) => v !== null && Object.prototype.toString.call(v) === '[object Object]';
                for (const entry of arr) {
                    if (isPlainObject(entry)) {
                        const keys = Object.keys(entry);
                        if (!keys.length) continue;
                        const idKey = keys.find(k => /^\d+$/.test(k)) || keys[0];
                        const inner = entry[idKey];
                        const urlStr = extractUrlString(inner);
                        if (urlStr && normalizeUrlForMatch(urlStr) === target) {
                            return idKey;
                        }
                    }
                }
                return null;
            };
            const fromContent = scanArray(blog?.ContentImages);
            if (fromContent) return fromContent;
            const fromImages = scanArray(blog?.images);
            if (fromImages) return fromImages;
        } catch {}
        return null;
    };

    const openConfirm = (message, onConfirm) => setConfirmState({ open: true, message, onConfirm });
    const closeConfirm = () => setConfirmState({ open: false, message: '', onConfirm: null });

    const handleDividerInsertion = () => {
        if (contentRef) {
            contentRef.focus();
            const hr = document.createElement('hr');
            hr.style.border = 'none'; hr.style.borderTop = '2px solid #e2e8f0'; hr.style.margin = '20px 0'; hr.style.width = '100%';
            const sel = window.getSelection();
            if (sel.rangeCount > 0) {
                const range = sel.getRangeAt(0);
                range.insertNode(hr);
                const brBefore = document.createElement('br'), brAfter = document.createElement('br');
                range.setStartBefore(hr); range.insertNode(brBefore); range.setStartAfter(hr); range.insertNode(brAfter); range.setStartAfter(brAfter); range.collapse(true); sel.removeAllRanges(); sel.addRange(range);
            } else {
                contentRef.appendChild(document.createElement('br')); contentRef.appendChild(hr); contentRef.appendChild(document.createElement('br'));
            }
            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
            setTimeout(ensureContentEditable, 0);
        }
    };

    const handleColumnInsertion = () => {
        if (contentRef) {
            contentRef.focus();
            const col = document.createElement('div');
            col.style.display = 'flex'; col.style.gap = '20px'; col.style.margin = '20px 0'; col.style.width = '100%';
            const left = document.createElement('div'), right = document.createElement('div');
            [left, right].forEach(c => { c.style.flex = '1'; c.style.minHeight = '100px'; c.style.border = '2px dashed #cbd5e1'; c.style.borderRadius = '8px'; c.style.padding = '15px'; c.style.backgroundColor = '#f8fafc'; c.contentEditable = true; });
            left.innerHTML = '<p style=\"margin: 0; color: #64748b; font-style: italic;\">Left Column Content</p>';
            right.innerHTML = '<p style=\"margin: 0; color: #64748b; font-style: italic;\">Right Column Content</p>';
            col.appendChild(left); col.appendChild(right);
            const sel = window.getSelection();
            if (sel.rangeCount > 0) {
                const range = sel.getRangeAt(0);
                range.insertNode(col);
                const brBefore = document.createElement('br'), brAfter = document.createElement('br');
                range.setStartBefore(col); range.insertNode(brBefore); range.setStartAfter(col); range.insertNode(brAfter); range.setStartAfter(brAfter); range.collapse(true); sel.removeAllRanges(); sel.addRange(range);
            } else {
                contentRef.appendChild(document.createElement('br')); contentRef.appendChild(col); contentRef.appendChild(document.createElement('br'));
            }
            setForm(prev => ({ ...prev, content: contentRef.innerHTML }));
            setTimeout(ensureContentEditable, 0);
        }
    };

    const handlePublish = () => {
        if (isSubmitting) return;
        const missingTitle = !form.title || !form.title.trim();
        const missingType = !form.contentType || !String(form.contentType).trim();
        if (missingTitle && missingType) {
            toast.error('Please enter a Blog Title and select a Type.');
            return;
        }
        if (missingTitle) {
            toast.error('Please enter a Blog Title.');
            return;
        }
        if (missingType) {
            toast.error('Please select a Type.');
            return;
        }
        
        if (!form.published) {
            setPublishConfirmState({ 
                open: true, 
                onConfirm: (shouldPublish) => {
                    if (shouldPublish) {
                        setForm(prev => ({ ...prev, published: true }));
                    }
                    setPublishConfirmState({ open: false, onConfirm: null });
                    executePublish(shouldPublish);
                }
            });
        } else {
            executePublish(true);
        }
    };

    const executePublish = (shouldPublish = false) => {
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('title', form.title);
        formData.append('subtitle', form.subtitles.filter(sub => sub.trim() !== '').join(','));
        formData.append('sortOrder', form.sortOrder);
        formData.append('contentType', form.contentType.toLowerCase());

        const contentDiv = document.createElement('div');
        contentDiv.innerHTML = form.content;
        const contentImages = [];
        let imageIndex = 0;

        const images = Array.from(contentDiv.querySelectorAll('img'));
        const filenameRegex = /contentImage-(\d+)\.(?:png|jpe?g|webp|gif)/i;
        const getIndexFromSrc = (src = '') => {
            try {
                const match = decodeURIComponent(src).match(filenameRegex);
                return match ? Number(match[1]) : 0;
            } catch {
                return 0;
            }
        };
        const contentImageStartIndex = images.reduce((maxIdx, img) => Math.max(maxIdx, getIndexFromSrc(img?.src)), 0);
        let currentIndex = contentImageStartIndex;
        for (const img of images) {
            const src = img?.src || '';
            if (src.startsWith('data:image/')) {
                contentImages.push(src);
                currentIndex += 1;
                const placeholder = document.createElement('span');
                placeholder.innerHTML = `[CONTENT_IMAGE_${currentIndex}]`;
                placeholder.style.cssText = 'display: inline-block; width: 100%; height: 200px; background-color: #f8fafc; border: 2px dashed #cbd5e1; border-radius: 4px; margin-bottom: 10px; text-align: center; line-height: 200px; color: #64748b; font-size: 14px;';
                img.replaceWith(placeholder);
            }
        }

        formData.append('content', contentDiv.innerHTML);
        formData.append('published', shouldPublish);
        formData.append('isActive', form.isActive);
        if (form?.coverImage) formData.append('coverImage', form.coverImage);
        const id = blog?.id || blogId || "";
        if (action === 'update' && id) formData.append('id', id);
        form.otherImages.forEach((file, index) => {
            if (file && file.name && file instanceof File) {
                formData.append('images', file);
            } else {
                const fileExtension = (file?.name || '').split('.').pop() || 'bin';
                const renamedFile = new File([file], `additionalFile-${index + 1}.${fileExtension}`, { type: file?.type || 'application/octet-stream' });
                formData.append('images', renamedFile);
            }
        });

        if (action === 'update' && existingImages.length > 0) {
            existingImages.forEach(url => formData.append('existingImages', url));
        }
        formData.append('keywords', form.keywords.filter(kw => kw.trim() !== '').join(','));

        contentImages.forEach((base64ImageSrc, idx) => {
            const arr = base64ImageSrc.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            for (let i = 0; i < n; ++i) u8arr[i] = bstr.charCodeAt(i);
            const fileIndex = contentImageStartIndex + idx + 1;
            const file = new File([u8arr], `contentImage-${fileIndex}.png`, { type: mime });
            formData.append('contentImages', file);
        });

        const apiCall = action === 'update' ? updateBlog(formData) : publishBlog(formData);
        apiCall.then(response => {
            if (response.responseCode === 200) onClose();
            else { toast.error('Blog action failed:', response); setIsSubmitting(false); }
        }).catch(err => { toast.error('Error while publishing/updating blog:', err); setIsSubmitting(false); });
    };

    const getFileTypeIcon = (file) => {
        let fileName = '';
        let fileType = '';
        if (typeof file === 'string') {
            fileName = decodeURIComponent(file.split('/').pop().split('?')[0]).toLowerCase();
        } else if (file instanceof File) {
            fileName = (file.name || '').toLowerCase();
            fileType = file.type || '';
        } else if (file && Object(file) === file && !Array.isArray(file)) {
            const maybeUrl = extractUrlString(file);
            if (maybeUrl) fileName = decodeURIComponent(maybeUrl.split('/').pop().split('?')[0]).toLowerCase();
        }
        if (!fileName && file) fileName = String(file).toLowerCase();

        if (fileType.startsWith('image/') || /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(fileName)) return <ImageIcon sx={{ fontSize: 32, color: '#667eea' }} />;
        if (fileName.endsWith('.pdf')) return <PdfIcon sx={{ fontSize: 32, color: '#ef4444' }} />;
        if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) return <DocIcon sx={{ fontSize: 32, color: '#2563eb' }} />;
        if (fileName.endsWith('.xls') || fileName.endsWith('.xlsx') || fileName.endsWith('.csv')) return <DocIcon sx={{ fontSize: 32, color: '#059669' }} />;
        if (fileName.endsWith('.ppt') || fileName.endsWith('.pptx')) return <DocIcon sx={{ fontSize: 32, color: '#dc2626' }} />;
        if (fileName.endsWith('.mp4') || fileName.endsWith('.mov') || fileName.endsWith('.avi') || fileName.endsWith('.wmv') || fileName.endsWith('.flv') || fileName.endsWith('.webm')) return <VideoIcon sx={{ fontSize: 32, color: '#7c3aed' }} />;
        if (fileName.endsWith('.mp3') || fileName.endsWith('.wav') || fileName.endsWith('.aac') || fileName.endsWith('.ogg')) return <AudioIcon sx={{ fontSize: 32, color: '#f59e0b' }} />;
        if (fileName.endsWith('.zip') || fileName.endsWith('.rar') || fileName.endsWith('.7z') || fileName.endsWith('.tar') || fileName.endsWith('.gz')) return <ArchiveIcon sx={{ fontSize: 32, color: '#059669' }} />;
        return <FileIcon sx={{ fontSize: 32, color: '#6b7280' }} />;
    };

    const getFileExtension = fileName => fileName.split('.').pop().toUpperCase();

    const formatFileSize = bytes => {
        if (bytes === 0) return '0 B';
        const k = 1024, sizes = ['B', 'KB', 'MB', 'GB'], i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    const tabs = [
        { label: 'Content', icon: <EditIcon /> },
        { label: 'Media', icon: <ImageIcon /> },
        { label: 'Settings', icon: <SettingsIcon /> }
    ];

    const renderFilePreview = (file, index) => (
        file.type && file.type.startsWith('image/') ? (
            <Box mt={2} key={index}>
                <img
                    src={URL.createObjectURL(file)}
                    alt={`file-${index}`}
                    style={{ width: 100, height: 100, borderRadius: 4, objectFit: 'cover' }}
                />
            </Box>
        ) : (
            <Box
                key={index}
                sx={{
                    width: 100,
                    height: 100,
                    borderRadius: 4,
                    border: '2px dashed #cbd5e1',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: 'rgba(248,250,252,0.8)',
                    p: 1.5
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                    {getFileTypeIcon(file)}
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        textAlign="center"
                        sx={{ fontSize: '0.65rem', fontWeight: 500, maxWidth: '85px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: 1.2 }}
                    >
                        {file.name.length > 10 ? file.name.substring(0, 10) + '...' : file.name}
                    </Typography>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        textAlign="center"
                        sx={{ fontSize: '0.6rem', fontWeight: 600, color: '#667eea', lineHeight: 1 }}
                    >
                        {getFileExtension(file.name)}
                    </Typography>
                </Box>
                <Typography
                    variant="caption"
                    color="textSecondary"
                    textAlign="center"
                    sx={{ fontSize: '0.55rem', lineHeight: 1 }}
                >
                    {formatFileSize(file.size)}
                </Typography>
            </Box>
        )
    );

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth sx={styles.dialog}>
                <DialogTitle sx={styles.dialogTitle}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ background: 'linear-gradient(45deg, #667eea, #764ba2)' }}>
                            <ArticleIcon />
                        </Avatar>
                        <Typography variant="h6" fontWeight="bold" fontFamily="'Poppins', sans-serif">
                            {action === 'update' ? 'Update Content' : 'Create New Content'}
                        </Typography>
                    </Box>
                    <IconButton onClick={onClose} disabled={isSubmitting} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={styles.dialogContent}>
                    <Box sx={styles.tabContainer}>
                        <Tabs
                            value={activeTab}
                            onChange={(e, newValue) => setActiveTab(newValue)}
                            sx={{ px: 3 }}
                        >
                            {tabs.map((tab, index) => (
                                <Tab
                                    key={index}
                                    label={tab.label}
                                    icon={tab.icon}
                                    iconPosition="start"
                                    sx={styles.tab}
                                />
                            ))}
                        </Tabs>
                    </Box>

                    {activeTab === 0 && (
                        <Box sx={styles.tabPanel}>
                            <Stack spacing={3}>
                                <Card sx={styles.card}>
                                    <Box sx={styles.cardHeader}>
                                        <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <TitleIcon /> Basic Information
                                        </Typography>
                                    </Box>
                                    <CardContent sx={styles.cardContent}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={5}>
                                                <TextField
                                                    fullWidth
                                                    label="Blog Title"
                                                    name="title"
                                                    value={form.title}
                                                    onChange={handleChange}
                                                    disabled={isSubmitting}
                                                    required
                                                    sx={styles.textField}
                                                    placeholder="Enter the main title of your blog"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    fullWidth
                                                    type="number"
                                                    label="Sort Order"
                                                    name="sortOrder"
                                                    value={form.sortOrder}
                                                    onChange={handleChange}
                                                    disabled={isSubmitting}
                                                    sx={styles.textField}
                                                    placeholder="1, 2, 3..."
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    label="Type"
                                                    name="contentType"
                                                    value={form.contentType}
                                                    onChange={handleChange}
                                                    disabled={isSubmitting}
                                                    required
                                                    sx={{ ...styles.textField, '& .MuiSelect-select': { minWidth: 120 } }}
                                                >
                                                    <MenuItem value="blog">Blog</MenuItem>
                                                    <MenuItem value="knowledge">Knowledge</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>

                                <Card sx={styles.card}>
                                    <Box sx={styles.cardHeader}>
                                        <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <EditIcon /> Content
                                        </Typography>
                                    </Box>
                                    <CardContent sx={styles.cardContent}>
                                        <Box sx={styles.formattingToolbar}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('bold'); }} sx={{ ...styles.formatButton, ...(formattingState.bold && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Bold"><FormatBoldIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('italic'); }} sx={{ ...styles.formatButton, ...(formattingState.italic && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Italic"><FormatItalicIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('underline'); }} sx={{ ...styles.formatButton, ...(formattingState.underline && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Underline"><FormatUnderlinedIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('strikethrough'); }} sx={{ ...styles.formatButton, ...(formattingState.strikethrough && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Strikethrough"><FormatStrikethroughIcon fontSize="small" /></IconButton>
                                            </Box>
                                            <Box sx={styles.toolbarVerticalDivider} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('listBullet'); }} sx={{ ...styles.formatButton, ...(formattingState.listBullet && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Bullet List"><FormatListBulletedIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('listNumber'); }} sx={{ ...styles.formatButton, ...(formattingState.listNumber && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Numbered List"><FormatListNumberedIcon fontSize="small" /></IconButton>
                                            </Box>
                                            <Box sx={styles.toolbarVerticalDivider} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('alignLeft'); }} sx={{ ...styles.formatButton, ...(formattingState.alignLeft && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Align Left"><FormatAlignLeftIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('alignCenter'); }} sx={{ ...styles.formatButton, ...(formattingState.alignCenter && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Align Center"><FormatAlignCenterIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('alignRight'); }} sx={{ ...styles.formatButton, ...(formattingState.alignRight && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Align Right"><FormatAlignRightIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleFormattingClick('alignJustify'); }} sx={{ ...styles.formatButton, ...(formattingState.alignJustify && { backgroundColor: 'rgba(102,126,234,0.2)', color: '#667eea' }) }} title="Justify"><FormatAlignJustifyIcon fontSize="small" /></IconButton>
                                            </Box>
                                            <Box sx={styles.toolbarVerticalDivider} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); document.getElementById('content-image-input').click(); }} sx={styles.formatButton} title="Insert Image"><ImageOutlinedIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleDividerInsertion(); }} sx={styles.formatButton} title="Insert Divider"><HorizontalRuleIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleColumnInsertion(); }} sx={styles.formatButton} title="Insert Column"><ViewColumnIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); setTableDialogOpen(true); }} sx={styles.formatButton} title="Insert Table"><TableChartIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleHyperlinkClick(); }} sx={styles.formatButton} title="Insert Hyperlink"><LinkIcon fontSize="small" /></IconButton>
                                            </Box>
                                            <Box sx={styles.toolbarVerticalDivider} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleSelectionChange(); setFontStyleDialogOpen(true); }} sx={styles.formatButton} title="Font Style"><TextFieldsIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleSelectionChange(); setFontSizeDialogOpen(true); }} sx={styles.formatButton} title="Font Size"><FormatSizeIcon fontSize="small" /></IconButton>
                                                <IconButton size="small" onClick={e => { e.preventDefault(); e.stopPropagation(); handleSelectionChange(); setColorDialogOpen(true); }} sx={styles.formatButton} title="Text Color"><FormatColorTextIcon fontSize="small" /></IconButton>
                                            </Box>
                                        </Box>

                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageInsertion}
                                            style={{ display: 'none' }}
                                            id="content-image-input"
                                        />

                                        <Box
                                            contentEditable
                                            ref={setContentRef}
                                            onInput={handleInput}
                                            onMouseUp={handleSelectionChange}
                                            onKeyUp={(e) => {
                                                if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) {
                                                    handleSelectionChange();
                                                }
                                            }}
                                            onBlur={updateSelectionRef}
                                            onKeyDown={handleKeyDown}
                                            sx={{
                                                ...styles.textField,
                                                ...styles.contentField,
                                                minHeight: '300px',
                                                border: '1px solid rgba(0,0,0,0.23)',
                                                borderRadius: 1,
                                                p: 2,
                                                '&:focus': {
                                                    outline: 'none',
                                                    borderColor: '#667eea',
                                                    borderWidth: '2px'
                                                },
                                                '&:hover': {
                                                    borderColor: '#667eea'
                                                }
                                            }}
                                            placeholder="Start writing your amazing blog content..."
                                        />
                                    </CardContent>
                                </Card>
                            </Stack>
                        </Box>
                    )}

                    {activeTab === 1 && (
                        <Box sx={styles.tabPanel}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={styles.card}>
                                        <Box sx={styles.cardHeader}>
                                            <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CameraIcon /> Cover Image
                                            </Typography>
                                        </Box>
                                        <CardContent sx={styles.cardContent}>
                                            <Box sx={styles.fileUploadArea}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleCoverUpload}
                                                    disabled={isSubmitting}
                                                    style={{ display: 'none' }}
                                                    id="cover-image-input"
                                                />
                                                <label htmlFor="cover-image-input">
                                                    <Box sx={{ cursor: 'pointer' }}>
                                                        <CloudUploadIcon sx={{ fontSize: 48, color: '#667eea', mb: 2 }} />
                                                        <Typography variant="body1" color="textSecondary" mb={1}>
                                                            Click to upload cover image
                                                        </Typography>
                                                        <Typography variant="caption" color="textSecondary">
                                                            Recommended: 1200x630px
                                                        </Typography>
                                                    </Box>
                                                </label>
                                            </Box>
                                            {form.coverImage && (
                                                <Box mt={2}>
                                                    <img
                                                        src={URL.createObjectURL(form.coverImage)}
                                                        alt="Cover"
                                                        style={{
                                                            width: '100%',
                                                            maxHeight: 200,
                                                            objectFit: 'cover',
                                                            borderRadius: 4
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            {!form.coverImage && (() => {
                                                const rawCover = blog?.coverImage;
                                                const coverUrl = extractUrlString(rawCover);
                                                if (!coverUrl || coverDeleted) return null;
                                                const resolveCoverId = (raw) => {
                                                    try {
                                                        if (!raw) return null;
                                                        const isString = (v) => Object.prototype.toString.call(v) === '[object String]';
                                                        const isPlainObject = (v) => v !== null && Object.prototype.toString.call(v) === '[object Object]';
                                                        if (isString(raw)) {
                                                            const m = String(raw).match(/^\s*(\d+)\s*\{/);
                                                            if (m && m[1]) return m[1];
                                                        }
                                                        if (isPlainObject(raw) && !Array.isArray(raw)) {
                                                            const keys = Object.keys(raw || {});
                                                            const idKey = keys.find(k => /^\d+$/.test(k)) || keys[0];
                                                            return idKey || null;
                                                        }
                                                    } catch {}
                                                    return null;
                                                };
                                                const coverId = resolveCoverId(rawCover);
                                                return (
                                                    <Box mt={2} position="relative" minHeight={200}>
                                                        {!coverImageLoaded && (
                                                        <Box
                                                            position="absolute"
                                                            top={0}
                                                            left={0}
                                                            width="100%"
                                                            height="100%"
                                                            bgcolor="#f3f4f6"
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            zIndex={0}
                                                            borderRadius={4}
                                                        >
                                                            <Typography variant="caption" color="textSecondary">Loading...</Typography>
                                                        </Box>
                                                        )}
                                                        <img
                                                            src={coverUrl}
                                                            alt="Existing Cover"
                                                            onLoad={() => setCoverImageLoaded(true)}
                                                            style={{
                                                                width: '100%',
                                                                maxHeight: 200,
                                                                objectFit: 'cover',
                                                                borderRadius: 4,
                                                                position: 'relative',
                                                                zIndex: 1
                                                            }}
                                                        />
                                                        <IconButton
                                                            size="small"
                                                            sx={{
                                                                position: 'absolute',
                                                                top: 8,
                                                                right: 8,
                                                                backgroundColor: 'white',
                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                width: 28,
                                                                height: 28,
                                                                zIndex: 2,
                                                                '&:hover': { backgroundColor: 'rgba(239,68,68,0.1)' }
                                                            }}
                                                            onClick={() => {
                                                                const doDelete = async () => {
                                                                    try {
                                                                        if (!coverId) {
                                                                            toast.error('Unable to resolve cover image id');
                                                                            return;
                                                                        }
                                                                        await deleteBlogImageById(coverId);
                                                                        toast.success('Cover image deleted successfully');
                                                                        setCoverDeleted(true);
                                                                    } catch (e) {
                                                                        toast.error('Failed to delete cover image');
                                                                    }
                                                                };
                                                                openConfirm('Delete this cover image?', doDelete);
                                                            }}
                                                            disabled={isSubmitting}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: 16 }} />
                                                        </IconButton>
                                                    </Box>
                                                );
                                            })()}
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={styles.card}>
                                        <Box sx={styles.cardHeader}>
                                            <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AttachFileIcon /> Additional Files
                                            </Typography>
                                        </Box>
                                        <CardContent sx={styles.cardContent}>
                                            <Box sx={styles.fileUploadArea}>
                                                <input
                                                    type="file"
                                                    accept="image/*,.pdf,.doc,.docx,.txt,.rtf,.odt,.pages,.xls,.xlsx,.csv,.ppt,.pptx,.key,.odp,.mp4,.mov,.avi,.wmv,.flv,.webm,.mp3,.wav,.aac,.ogg,.zip,.rar,.7z,.tar,.gz"
                                                    multiple
                                                    onChange={handleOtherImagesUpload}
                                                    disabled={isSubmitting}
                                                    style={{ display: 'none' }}
                                                    id="other-images-input"
                                                />
                                                <label htmlFor="other-images-input">
                                                    <Box sx={{ cursor: 'pointer' }}>
                                                        <CloudUploadIcon sx={{ fontSize: 48, color: '#667eea', mb: 2 }} />
                                                        <Typography variant="body1" color="textSecondary" mb={1}>
                                                            Click to upload images and documents
                                                        </Typography>
                                                        <Typography variant="caption" color="textSecondary">
                                                            Supported: Images, PDFs, Documents, Videos, Audio, Archives
                                                        </Typography>
                                                    </Box>
                                                </label>
                                            </Box>

                                            <Grid container spacing={2} mt={2}>
                                                {form.otherImages.map((file, index) => (
                                                    <Grid item key={`upload-${index}`}>
                                                        <Box position="relative">
                                                            {renderFilePreview(file, index)}
                                                            <IconButton
                                                                size="small"
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: -8,
                                                                    right: -8,
                                                                    backgroundColor: 'white',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                    width: 24,
                                                                    height: 24,
                                                                    zIndex: 2,
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(239,68,68,0.1)'
                                                                    }
                                                                }}
                                                                onClick={() => removeOtherImage(index)}
                                                                disabled={isSubmitting}
                                                            >
                                                                <DeleteIcon sx={{ fontSize: 14 }} />
                                                            </IconButton>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                                {existingImages.map((url, index) => {
                                                    const urlStr = extractUrlString(url);
                                                    const getFileExtension = (fileName) => decodeURIComponent(fileName.split('/').pop().split('?')[0]).split('.').pop().toUpperCase();
                                                    const isImage = (fileUrl) => /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(decodeURIComponent(fileUrl.split('/').pop().split('?')[0]));
                                                    const fileName = decodeURIComponent(urlStr.split('/').pop().split('?')[0]);
                                                    return (
                                                        <Grid item key={`existing-${index}`}>
                                                            <Box position="relative">
                                                                {isImage(urlStr) ? (
                                                                    <Box position="relative" minHeight={100}>
                                                                        <Box
                                                                            position="absolute"
                                                                            top={0}
                                                                            left={0}
                                                                            width={100}
                                                                            height={100}
                                                                            bgcolor="#f3f4f6"
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            justifyContent="center"
                                                                            zIndex={0}
                                                                            borderRadius={4}
                                                                        >
                                                                            <Typography variant="caption" color="textSecondary">Loading...</Typography>
                                                                        </Box>
                                                                        <img
                                                                            src={urlStr}
                                                                            alt={`existing-${index}`}
                                                                            style={{ width: 100, height: 100, borderRadius: 4, objectFit: 'cover', position: 'relative', zIndex: 1 }}
                                                                        />
                                                                    </Box>
                                                                ) : (
                                                                    <Box
                                                                        sx={{
                                                                            width: 100,
                                                                            height: 100,
                                                                            borderRadius: 4,
                                                                            border: '2px dashed #cbd5e1',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'space-between',
                                                                            background: 'rgba(248,250,252,0.8)',
                                                                            p: 1.5
                                                                        }}
                                                                    >
                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                                            {getFileTypeIcon(urlStr)}
                                                                            <Typography
                                                                                variant="caption"
                                                                                color="textSecondary"
                                                                                textAlign="center"
                                                                                sx={{
                                                                                    fontSize: '0.65rem',
                                                                                    fontWeight: 500,
                                                                                    maxWidth: '85px',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap',
                                                                                    lineHeight: 1.2
                                                                                }}
                                                                            >
                                                                                {fileName.length > 10 ? fileName.substring(0, 10) + '...' : fileName}
                                                                            </Typography>
                                                                            <Typography
                                                                                variant="caption"
                                                                                color="textSecondary"
                                                                                textAlign="center"
                                                                                sx={{
                                                                                    fontSize: '0.6rem',
                                                                                    fontWeight: 600,
                                                                                    color: '#667eea',
                                                                                    lineHeight: 1
                                                                                }}
                                                                            >
                                                                                {getFileExtension(urlStr)}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: -8,
                                                                        right: -8,
                                                                        backgroundColor: 'white',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                        width: 24,
                                                                        height: 24,
                                                                        zIndex: 2,
                                                                        '&:hover': { backgroundColor: 'rgba(239,68,68,0.1)' }
                                                                    }}
                                                                    onClick={() => {
                                                                        const doDelete = async () => {
                                                                            try {
                                                                                const resolvedId = resolveImageIdByUrl(urlStr);
                                                                                if (!resolvedId) {
                                                                                    toast.error('Unable to resolve file id');
                                                                                    return;
                                                                                }
                                                                                await deleteBlogImageById(resolvedId);
                                                                                toast.success('File deleted successfully');
                                                                                const newExistingImages = existingImages.filter((_, i) => i !== index);
                                                                                setExistingImages(newExistingImages);
                                                                            } catch (e) {
                                                                                toast.error('Failed to delete file');
                                                                            }
                                                                        };
                                                                        openConfirm('Delete this file?', doDelete);
                                                                    }}
                                                                    disabled={isSubmitting}
                                                                >
                                                                    <DeleteIcon sx={{ fontSize: 14 }} />
                                                                </IconButton>
                                                            </Box>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {activeTab === 2 && (
                        <Box sx={styles.tabPanel}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={styles.card}>
                                        <Box sx={styles.cardHeader}>
                                            <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <PublishIcon /> Publication Settings
                                            </Typography>
                                        </Box>
                                        <CardContent sx={styles.cardContent}>
                                            <Box sx={styles.statusCard}>
                                                <Chip
                                                    label={form.published ? "Published" : "Draft"}
                                                    color={form.published ? "success" : "warning"}
                                                    size="small"
                                                    sx={styles.chip}
                                                />
                                                <Typography variant="body2" color="textSecondary">
                                                    Publication Status
                                                </Typography>
                                            </Box>
                                            <RadioGroup
                                                name="published"
                                                value={String(form.published)}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                                sx={styles.radioGroup}
                                            >
                                                <FormControlLabel
                                                    value="true"
                                                    control={<Radio size="small" disabled={isSubmitting} />}
                                                    label="Publish immediately"
                                                />
                                                <FormControlLabel
                                                    value="false"
                                                    control={<Radio size="small" disabled={isSubmitting} />}
                                                    label="Save as draft"
                                                />
                                            </RadioGroup>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Card sx={styles.card}>
                                        <Box sx={styles.cardHeader}>
                                            <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <VisibilityIcon /> Status Settings
                                            </Typography>
                                        </Box>
                                        <CardContent sx={styles.cardContent}>
                                            <Box sx={styles.statusCard}>
                                                <Chip
                                                    label={form.isActive ? "Active" : "Inactive"}
                                                    color={form.isActive ? "success" : "error"}
                                                    size="small"
                                                    sx={styles.chip}
                                                />
                                                <Typography variant="body2" color="textSecondary">
                                                    Content Status
                                                </Typography>
                                            </Box>
                                            <RadioGroup
                                                name="isActive"
                                                value={String(form.isActive)}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                                sx={styles.radioGroup}
                                            >
                                                <FormControlLabel
                                                    value="true"
                                                    control={<Radio size="small" disabled={isSubmitting} />}
                                                    label="Active (visible to users)"
                                                />
                                                <FormControlLabel
                                                    value="false"
                                                    control={<Radio size="small" disabled={isSubmitting} />}
                                                    label="Inactive (hidden from users)"
                                                />
                                            </RadioGroup>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions sx={styles.dialogActions}>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={styles.cancelButton}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handlePublish}
                        variant="contained"
                        disabled={isSubmitting}
                        sx={styles.submitButton}
                    >
                        {isSubmitting ? (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CircularProgress size={18} sx={{ color: 'white', mr: 1 }} />
                                <span>Processing...</span>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {action === 'update' ? <UpdateIcon /> : <CreateIcon />}
                                {action === 'update' ? 'Update Content' : 'Publish Content'}
                            </Box>
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tableDialogOpen}
                onClose={() => setTableDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 600
                }}>
                    <TableChartIcon />
                    Insert Table
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={3}>
                        <Typography variant="body1" color="textSecondary">
                            Select the number of rows and columns for your table:
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Number of Rows"
                                    value={tableConfig.rows}
                                    onChange={(e) => setTableConfig(prev => ({ ...prev, rows: Math.max(1, parseInt(e.target.value) || 1) }))}
                                    inputProps={{ min: 1, max: 20 }}
                                    sx={styles.textField}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Number of Columns"
                                    value={tableConfig.columns}
                                    onChange={(e) => setTableConfig(prev => ({ ...prev, columns: Math.max(1, parseInt(e.target.value) || 1) }))}
                                    inputProps={{ min: 1, max: 10 }}
                                    sx={styles.textField}
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{
                            border: '1px solid #e2e8f0',
                            borderRadius: 2,
                            p: 2,
                            background: '#f8fafc',
                            textAlign: 'center'
                        }}>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                Preview: {tableConfig.rows} × {tableConfig.columns} table
                            </Typography>
                            <Box sx={{
                                display: 'inline-block',
                                border: '1px solid #cbd5e1',
                                borderRadius: 1,
                                overflow: 'hidden'
                            }}>
                                {Array.from({ length: Math.min(tableConfig.rows, 3) }, (_, i) => (
                                    <Box key={i} sx={{ display: 'flex' }}>
                                        {Array.from({ length: Math.min(tableConfig.columns, 5) }, (_, j) => (
                                            <Box
                                                key={j}
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    border: '1px solid #e2e8f0',
                                                    backgroundColor: i === 0 ? '#667eea' : (i % 2 === 0 ? '#f1f5f9' : 'white'),
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '10px',
                                                    color: i === 0 ? 'white' : 'inherit'
                                                }}
                                            >
                                                {i === 0 ? 'H' : 'C'}
                                            </Box>
                                        ))}
                                    </Box>
                                ))}
                                {tableConfig.rows > 3 && (
                                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
                                        ... and {tableConfig.rows - 3} more rows
                                    </Typography>
                                )}
                                {tableConfig.columns > 5 && (
                                    <Typography variant="caption" color="textSecondary">
                                        ... and {tableConfig.columns - 5} more columns
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: 3, gap: 1 }}>
                    <Button
                        onClick={() => setTableDialogOpen(false)}
                        variant="outlined"
                        sx={styles.cancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleTableInsertion}
                        variant="contained"
                        sx={styles.submitButton}
                    >
                        Insert Table
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tableRowDialogOpen}
                onClose={() => setTableRowDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={styles.dialogTitle}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TableChartIcon /> Table Row Operation
                    </Typography>
                    <IconButton onClick={() => setTableRowDialogOpen(false)} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={3}>
                        <Typography variant="body1" color="textSecondary">
                            {rowOperation.type === 'add' ? 'Add a new row to the table' : 'Remove a row from the table'}
                        </Typography>

                        {rowOperation.type === 'add' && (
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                    Choose position to add row:
                                </Typography>
                                <Stack spacing={2}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => addTableRow('start')}
                                        startIcon={<AddIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Add at the beginning
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => addTableRow('end')}
                                        startIcon={<AddIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Add at the end
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            const rowIndex = prompt('Enter row number to insert after (1, 2, 3, etc.):');
                                            if (rowIndex && !isNaN(rowIndex)) {
                                                addTableRow('between', parseInt(rowIndex) - 1);
                                            }
                                        }}
                                        startIcon={<AddIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Add between existing rows
                                    </Button>
                                </Stack>
                            </Box>
                        )}

                        {rowOperation.type === 'remove' && (
                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                    Choose row to remove:
                                </Typography>
                                <Stack spacing={2}>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => removeTableRow('start')}
                                        startIcon={<DeleteIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Remove first row
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => removeTableRow('end')}
                                        startIcon={<DeleteIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Remove last row
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => {
                                            const rowIndex = prompt('Enter row number to remove (1, 2, 3, etc.):');
                                            if (rowIndex && !isNaN(rowIndex)) {
                                                removeTableRow('between', parseInt(rowIndex) - 1);
                                            }
                                        }}
                                        startIcon={<DeleteIcon />}
                                        fullWidth
                                        sx={{ justifyContent: 'flex-start', textAlign: 'left' }}
                                    >
                                        Remove specific row
                                    </Button>
                                </Stack>
                            </Box>
                        )}
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: 3, gap: 1 }}>
                    <Button
                        onClick={() => setTableRowDialogOpen(false)}
                        variant="outlined"
                        sx={styles.cancelButton}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {contextMenu.visible && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: contextMenu.y,
                        left: contextMenu.x,
                        zIndex: 9999,
                        background: 'white',
                        border: '1px solid #e2e8f0',
                        borderRadius: 2,
                        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                        minWidth: 200,
                        py: 1
                    }}
                    onClick={handleContextMenuClose}
                >
                    <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #f1f5f9' }}>
                        <Typography variant="subtitle2" fontWeight="bold" color="textSecondary">
                            Table Row Operations
                        </Typography>
                    </Box>

                    <Box sx={{ py: 1 }}>
                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f8fafc' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const tbody = table.querySelector('tbody');
                                const row = contextMenu.targetCell.closest('tr');
                                const rowIndex = Array.from(tbody.children).indexOf(row);
                                handleContextMenuAction('add', 'between', rowIndex);
                            }}
                        >
                            <AddIcon fontSize="small" />
                            <Typography variant="body2">Add row above</Typography>
                        </Box>

                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f8fafc' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const tbody = table.querySelector('tbody');
                                const row = contextMenu.targetCell.closest('tr');
                                const rowIndex = Array.from(tbody.children).indexOf(row);
                                handleContextMenuAction('add', 'between', rowIndex + 1);
                            }}
                        >
                            <AddIcon fontSize="small" />
                            <Typography variant="body2">Add row below</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ borderTop: '1px solid #f1f5f9', py: 1 }}>
                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#fef2f2' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: '#ef4444'
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const tbody = table.querySelector('tbody');
                                const row = contextMenu.targetCell.closest('tr');
                                const rowIndex = Array.from(tbody.children).indexOf(row);
                                handleContextMenuAction('remove', 'between', rowIndex);
                            }}
                        >
                            <DeleteIcon fontSize="small" />
                            <Typography variant="body2">Delete row</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ borderTop: '1px solid #f1f5f9', py: 1 }}>
                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f8fafc' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const row = contextMenu.targetCell.closest('tr');
                                const cellIndex = Array.from(row.children).indexOf(contextMenu.targetCell);
                                handleContextMenuAction('addColumn', 'between', cellIndex);
                            }}
                        >
                            <AddIcon fontSize="small" />
                            <Typography variant="body2">Add column left</Typography>
                        </Box>

                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f8fafc' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const row = contextMenu.targetCell.closest('tr');
                                const cellIndex = Array.from(row.children).indexOf(contextMenu.targetCell);
                                handleContextMenuAction('addColumn', 'between', cellIndex + 1);
                            }}
                        >
                            <AddIcon fontSize="small" />
                            <Typography variant="body2">Add column right</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ borderTop: '1px solid #f1f5f9', py: 1 }}>
                        <Box
                            sx={{
                                px: 2,
                                py: 1,
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#fef2f2' },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: '#ef4444'
                            }}
                            onClick={() => {
                                const table = contextMenu.targetCell.closest('table');
                                const row = contextMenu.targetCell.closest('tr');
                                const cellIndex = Array.from(row.children).indexOf(contextMenu.targetCell);
                                handleContextMenuAction('removeColumn', 'between', cellIndex);
                            }}
                        >
                            <DeleteIcon fontSize="small" />
                            <Typography variant="body2">Delete column</Typography>
                        </Box>
                    </Box>
                </Box>
            )}

            <Dialog
                open={hyperlinkDialogOpen}
                onClose={() => setHyperlinkDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={styles.dialogTitle}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LinkIcon /> Insert Hyperlink
                    </Typography>
                    <IconButton onClick={() => setHyperlinkDialogOpen(false)} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={3}>
                        <Typography variant="body1" color="textSecondary">
                            Enter the URL and link text for your hyperlink:
                        </Typography>

                        <TextField
                            fullWidth
                            label="URL"
                            value={hyperlinkData.url}
                            onChange={(e) => setHyperlinkData(prev => ({ ...prev, url: e.target.value }))}
                            placeholder="https://example.com"
                            sx={styles.textField}
                        />

                        <TextField
                            fullWidth
                            label="Link Text (optional)"
                            value={hyperlinkData.text}
                            onChange={(e) => setHyperlinkData(prev => ({ ...prev, text: e.target.value }))}
                            placeholder="Display text for the link"
                            sx={styles.textField}
                            helperText="Leave empty to use the URL as display text"
                        />
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ p: 3, gap: 1 }}>
                    <Button
                        onClick={() => setHyperlinkDialogOpen(false)}
                        variant="outlined"
                        sx={styles.cancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleHyperlinkInsertion}
                        variant="contained"
                        disabled={!hyperlinkData.url.trim()}
                        sx={styles.submitButton}
                    >
                        Insert Link
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={fontStyleDialogOpen}
                onClose={() => setFontStyleDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={styles.dialogTitle}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextFieldsIcon /> Font Style
                    </Typography>
                    <IconButton onClick={() => setFontStyleDialogOpen(false)} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Typography variant="body1" color="textSecondary">
                            Select a font style for the selected text:
                        </Typography>
                        <Grid container spacing={2}>
                            {['Arial', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New', 'Helvetica'].map((style) => (
                                <Grid item xs={6} key={style}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => handleFontStyleChange(style)}
                                        sx={{
                                            fontFamily: style,
                                            justifyContent: 'flex-start',
                                            textAlign: 'left',
                                            borderColor: fontStyle === style ? '#667eea' : '#e2e8f0',
                                            color: fontStyle === style ? '#667eea' : 'inherit',
                                            backgroundColor: fontStyle === style ? 'rgba(102,126,234,0.08)' : 'transparent',
                                            fontWeight: fontStyle === style ? 700 : 400,
                                            '&:hover': {
                                                borderColor: '#667eea',
                                                backgroundColor: 'rgba(102,126,234,0.05)'
                                            }
                                        }}
                                    >
                                        {style}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Stack>
                </DialogContent>
            </Dialog>

            <Dialog
                open={fontSizeDialogOpen}
                onClose={() => setFontSizeDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={styles.dialogTitle}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FormatSizeIcon /> Font Size
                    </Typography>
                    <IconButton onClick={() => setFontSizeDialogOpen(false)} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Typography variant="body1" color="textSecondary">
                            Select a font size for the selected text:
                        </Typography>
                        <Grid container spacing={2}>
                            {['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'].map((size) => (
                                <Grid item xs={3} key={size}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => handleFontSizeChange(size)}
                                        sx={{
                                            fontSize: size,
                                            justifyContent: 'center',
                                            borderColor: fontSize === size ? '#667eea' : '#e2e8f0',
                                            color: fontSize === size ? '#667eea' : 'inherit',
                                            backgroundColor: fontSize === size ? 'rgba(102,126,234,0.08)' : 'transparent',
                                            fontWeight: fontSize === size ? 700 : 400,
                                            '&:hover': {
                                                borderColor: '#667eea',
                                                backgroundColor: 'rgba(102,126,234,0.05)'
                                            }
                                        }}
                                    >
                                        {size}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Stack>
                </DialogContent>
            </Dialog>

            <Dialog
                open={colorDialogOpen}
                onClose={() => setColorDialogOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={styles.dialogTitle}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FormatColorTextIcon /> Text Color
                    </Typography>
                    <IconButton onClick={() => setColorDialogOpen(false)} sx={styles.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Stack spacing={2}>
                        <Typography variant="body1" color="textSecondary">
                            Select a color for the selected text:
                        </Typography>
                        <Grid container spacing={2}>
                            {[
                                { name: 'Black', value: '#000000' },
                                { name: 'Red', value: '#ef4444' },
                                { name: 'Blue', value: '#3b82f6' },
                                { name: 'Green', value: '#10b981' },
                                { name: 'Purple', value: '#8b5cf6' },
                                { name: 'Orange', value: '#f97316' },
                                { name: 'Pink', value: '#ec4899' },
                                { name: 'Gray', value: '#6b7280' }
                            ].map((color) => (
                                <Grid item xs={3} key={color.value}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => handleColorChange(color.value)}
                                        sx={{
                                            color: color.value,
                                            borderColor: textColor === color.value ? color.value : '#e2e8f0',
                                            backgroundColor: textColor === color.value ? `${color.value}10` : 'transparent',
                                            fontWeight: textColor === color.value ? 700 : 400,
                                            boxShadow: textColor === color.value ? `0 0 0 2px ${color.value}33` : 'none',
                                            '&:hover': {
                                                borderColor: color.value,
                                                backgroundColor: `${color.value}20`
                                            }
                                        }}
                                    >
                                        {color.name}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Stack>
        </DialogContent>
            </Dialog>
            <Dialog
                open={confirmState.open}
                onClose={closeConfirm}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: 3, background: 'rgba(255,255,255,0.98)' }
                }}
            >
                <DialogTitle sx={{ fontWeight: 700 }}>Confirm Deletion</DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Typography variant="body2" color="textSecondary">
                        {confirmState.message || 'Are you sure you want to delete this item?'}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={closeConfirm} variant="outlined" sx={styles.cancelButton}>Cancel</Button>
                    <Button
                        onClick={async () => {
                            const fn = confirmState.onConfirm;
                            closeConfirm();
                            if (typeof fn === 'function') await fn();
                        }}
                        color="error"
                        variant="contained"
                        sx={styles.submitButton}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={publishConfirmState.open}
                onClose={() => setPublishConfirmState({ open: false, onConfirm: null })}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 600
                }}>
                    <PublishIcon />
                    Publish Content
                </DialogTitle>
                <DialogContent sx={{ p: 2, pb: 0, mt: 2 }}>
                    <Typography variant="body1" color="textSecondary">
                        Do you want to publish the content immediately?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 3, gap: 1 }}>
                    <Button
                        onClick={() => {
                            const fn = publishConfirmState.onConfirm;
                            setPublishConfirmState({ open: false, onConfirm: null });
                            if (typeof fn === 'function') fn(false);
                        }}
                        variant="outlined"
                        sx={styles.cancelButton}
                    >
                        No, Save as Draft
                    </Button>
                    <Button
                        onClick={() => {
                            const fn = publishConfirmState.onConfirm;
                            setPublishConfirmState({ open: false, onConfirm: null });
                            if (typeof fn === 'function') fn(true);
                        }}
                        variant="contained"
                        sx={styles.submitButton}
                    >
                        Yes, Publish Now
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PublishBlogModal;